import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/App.css';
import Sidebar from './components/common/Sidebar';
import Header from './components/common/Header';
import AppRoutes from './routes/AppRoutes';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import demoDataService from './services/DemoDataService';

library.add(fas);

function App() {

  useEffect(() => {
    demoDataService.populateDatabaseIfEmpty();
  }, []);

  return (
    <Router>
      <div className="app-container">
        <Sidebar />
        <div className="main-content">
          <Header />
          <div className="page-content">
            <AppRoutes />
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
